import { gql, TypedDocumentNode } from '@apollo/client';

import {
  MyOAuthConnectionsQuery,
  MyOAuthConnectionsQueryVariables,
} from '../generated';

export const MY_OAUTH_CONNECTIONS: TypedDocumentNode<
  MyOAuthConnectionsQuery,
  MyOAuthConnectionsQueryVariables
> = gql`
  query MyOAuthConnections {
    myOAuthConnections {
      id
      provider
      providerAccountId
      description
      metadata
      scopes
      createdAt
      updatedAt
    }
  }
`;
